import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b70035c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-5/6 sm:w-4/6 xl:w-2/6 mx-auto mb-8" }
const _hoisted_2 = { class: "text-center my-8 md:my-16" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-x-3" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-x-3" }
const _hoisted_6 = {
  style: {"font-size":"15px"},
  class: "ml-4"
}
const _hoisted_7 = {
  style: {"font-size":"15px"},
  class: "ml-4"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  style: {"font-size":"15px"},
  class: "ml-4"
}
const _hoisted_10 = { class: "grid grid-cols-2 gap-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Vaši podatki")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.contact
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_form_item, {
                name: "firstName",
                rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: _ctx.$t('Ime'),
                    value: _ctx.contact.firstName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact.firstName) = $event))
                  }, null, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_form_item, {
                name: "lastName",
                rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: _ctx.$t('Priimek'),
                    value: _ctx.contact.lastName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contact.lastName) = $event))
                  }, null, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["rules"])
            ])
          ]),
          _createVNode(_component_a_form_item, {
            name: "email",
            rules: {
                     required: true,
                     validator: _ctx.validateEmail
                   }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: _ctx.$t('Elektronski naslov'),
                value: _ctx.contact.email,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contact.email) = $event))
              }, null, 8, ["placeholder", "value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            name: "phone",
            rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: _ctx.$t('Telefon'),
                value: _ctx.contact.phone,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contact.phone) = $event))
              }, null, 8, ["placeholder", "value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("Naslov")), 1),
          _createVNode(_component_a_form_item, {
            name: "address",
            rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: _ctx.$t('Naslov'),
                value: _ctx.contact.address,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contact.address) = $event))
              }, null, 8, ["placeholder", "value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_form_item, {
                name: "city",
                rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: _ctx.$t('Mesto'),
                    value: _ctx.contact.city,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contact.city) = $event))
                  }, null, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_form_item, {
                name: "postalCode",
                rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: _ctx.$t('Poštna številka'),
                    value: _ctx.contact.postalCode,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contact.postalCode) = $event))
                  }, null, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["rules"])
            ])
          ]),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("Prevoz")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "w-fit inputSelect mb-3",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.contact.deliveryType = 'pickup'))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contact.deliveryType) = $event)),
                type: "radio",
                name: "deliveryType",
                value: "pickup"
              }, null, 512), [
                [_vModelRadio, _ctx.contact.deliveryType]
              ]),
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Prevzel bom sam")), 1)
            ]),
            _createElementVNode("div", {
              class: "w-fit inputSelect mb-3",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.contact.deliveryType = 'delivery'))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contact.deliveryType) = $event)),
                type: "radio",
                name: "deliveryType",
                value: "delivery"
              }, null, 512), [
                [_vModelRadio, _ctx.contact.deliveryType]
              ]),
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Želim dostavo")), 1)
            ])
          ]),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_ctx.contact.deliveryType === 'delivery')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("Dostava")), 1),
                    _createElementVNode("div", {
                      class: "w-full inputSelect mb-3",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.contact.sameDeliveryAddress = !_ctx.contact.sameDeliveryAddress;})
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contact.sameDeliveryAddress) = $event)),
                        type: "checkbox",
                        name: "sameDeliveryAddress"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.contact.sameDeliveryAddress]
                      ]),
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Naslov za dostavo je enak mojemu naslovu")), 1)
                    ]),
                    _createVNode(_component_a_form_item, {
                      name: "deliveryAddress",
                      rules: !_ctx.contact.sameDeliveryAddress && _ctx.contact.deliveryType === 'delivery' && {
                     required: true,
                     validator: _ctx.validateArea
                   }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: _ctx.$t('Naslov'),
                          disabled: _ctx.contact.sameDeliveryAddress,
                          value: _ctx.contact.deliveryAddress,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.contact.deliveryAddress) = $event))
                        }, null, 8, ["placeholder", "disabled", "value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_form_item, {
                          name: "deliveryCity",
                          rules: !_ctx.contact.sameDeliveryAddress && _ctx.contact.deliveryType === 'delivery' && {
                     required: true,
                     validator: _ctx.validateArea
                   }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: _ctx.$t('Mesto'),
                              disabled: _ctx.contact.sameDeliveryAddress,
                              value: _ctx.contact.deliveryCity,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.contact.deliveryCity) = $event))
                            }, null, 8, ["placeholder", "disabled", "value"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_form_item, {
                          name: "deliveryPostalCode",
                          rules: !_ctx.contact.sameDeliveryAddress && _ctx.contact.deliveryType === 'delivery' && {
                     required: true,
                     validator: _ctx.validateArea
                   }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: _ctx.$t('Poštna številka'),
                              disabled: _ctx.contact.sameDeliveryAddress,
                              value: _ctx.contact.deliveryPostalCode,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contact.deliveryPostalCode) = $event))
                            }, null, 8, ["placeholder", "disabled", "value"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("Opomba")), 1),
          _createVNode(_component_a_form_item, { name: "note" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                rows: 4,
                placeholder: _ctx.$t('Vpišite opombo'),
                value: _ctx.contact.note,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contact.note) = $event)),
                style: {"border-radius":"6px","min-height":"100px"}
              }, null, 8, ["placeholder", "value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}